import { createIcon } from '@chakra-ui/icons';

export const HeavyCheck = createIcon({
  displayName: 'HeavyCheck',
  viewBox: '0 0 16 17',
  path: [
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_678_34094)">
        <path
          d="M15.8544 3.64629L14.8544 2.64629C14.6764 2.46729 14.3934 2.45129 14.1944 2.60529L5.49437 9.37129L1.80037 6.60029C1.60337 6.45029 1.32237 6.47029 1.14737 6.64629L0.146371 7.64629C-0.0366286 7.82929 -0.0496286 8.12129 0.116371 8.32029L5.11637 14.3203C5.20637 14.4283 5.33737 14.4933 5.47737 14.4993C5.48537 14.4993 5.49237 14.4993 5.49937 14.4993C5.63137 14.4993 5.75937 14.4473 5.85337 14.3533L15.8544 4.35429C16.0494 4.15929 16.0494 3.84229 15.8544 3.64729V3.64629Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_678_34094">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
